<template>
    <div class="compare-to-donor-component">
      <v-dialog
        v-if="show_in_dialog"
        v-model="dialog"
        :fullscreen="$vuetify.display.mobile"
      >
        <template v-slot:activator="{ attrs }">
          <div v-bind="attrs" @click="showDialog">
            <div :class="['d-flex text-left button-details justify-space-between align-center', isReservationOrDepositType ? 'pa-3' : 'pa-6',
            oidc_user?.roles.includes('ROLE_PATIENT_COORDINATOR') ? 'coor-reservations-list' : ''
            ]" >
              <img src="@/assets/img/compare_phenotype_img.svg" v-if="!oidc_user?.roles.includes('ROLE_PATIENT_COORDINATOR')"
                :class="[isReservationOrDepositType ? 'mr-3' : 'mr-6']"/>
              <div class="flex-grow-1" :class="[isReservationOrDepositType ? 'mr-3' : 'mr-6']">
                <div v-if="isReservationOrDepositType">
                  <div class="panel_header">{{ $t("donor.compare.compare_with_phenotype_data_btn") }}</div>
                </div>
                <div v-else>
                  <div class="panel_header">{{ $t("donor.phenotype.compare_to_own_phenotype") }}</div>
                  <div class="panel_subheader">{{ $t("donor.phenotype.compare_to_own_phenotype_label") }}</div>
                </div>
              </div>
              <div class="panel_shevron">
                <img v-if="!dataFetching" src="@/assets/img/panel_chevron_right.svg"/>
                <v-progress-circular
                  v-else
                  indeterminate
                  color="primary"
                  :size="24"
                  :width="2"
                ></v-progress-circular>
              </div>
            </div>
          </div>
        </template>

        <v-card>
          <div class="close" :class="{'mobile': $vuetify.display.mobile}" @click="dialog = false">
            <v-icon color="primary">mdi-close</v-icon>
          </div>
          <div class="modal-header ml-4 mt-6 mb-12 mr-12 mr-md-0">
            <span v-if="oidc_user?.roles.includes('ROLE_PATIENT')">
              {{$t('donor.compare.comparing_with_phenotypes_header', {donor: getDonorGender2, partner: getPartnerGender2})}}
            </span>
            <span v-else>
              {{$t('donor.compare.phenotype_comparison_header')}}
            </span>
          </div>

          <compare-to-donor-data-component 
              :donor_phenotype="donor_phenotype"
              :donor_nickname="donor_nickname"
              :donor_id="donor_id"
              :donor_product_key="donor_product_key"
              :donor_material_type="donor_material_type"
              :user_id="user_id"
              :oidc_user="oidc_user"
              :action="action"
              :compare_fetched_table="compareFetchedTable"
              @close-compare-dialog="hideDialog">
          </compare-to-donor-data-component>

        </v-card>
      </v-dialog>
      <v-card v-else 
        color="secondarybg"
        rounded="0"
        variant="outlined"
        class="text-left pt-6">
        
        <compare-to-donor-data-component 
            :donor_phenotype="donor_phenotype"
            :donor_nickname="donor_nickname"
            :donor_id="donor_id"
            :donor_product_key="donor_product_key"
            :donor_material_type="donor_material_type"
            :user_id="user_id"
            :oidc_user="oidc_user"
            :action="action"
            :compare_fetched_table="compareFetchedTable">
        </compare-to-donor-data-component>

      </v-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from "axios";
import CompareToDonorDataComponent from './CompareToDonorDataComponent.vue';

export default {
    name: "compare-to-donor-component",
    components: {
      CompareToDonorDataComponent,
    },
    data: () => {
      return {
        dialog: false,
        compareFetchedTable: {},
        dataFetching: false,
      }
    },
    props: {
      show_in_dialog: {
        type: Boolean,
        required: false,
        default: true
      },
      donor_phenotype: {
        type: Object,
        required: true
      },
      donor_id: {
        type: String,
        required: false
      },
      donor_nickname: {
        type: String,
        required: true
      },
      donor_product_key: {
        type: String,
        required: true
      },
      donor_material_type: {
        type: String,
        required: true
      },
      oidc_user: {
        type: Object,
        required: true
      },
      user_id: {
        type: Number,
        required: false
      },
      action: {
        type: String,
        required: false,
        default: 'reserve'
      },
      type: {
        type: String,
        required: false,
        default: 'user'
      },
      reservation_id: {
        type: Number,
        required: false
      }
    },
    computed: {
      ...mapGetters('phenotypeModule',['getPhenotype']),
      isReservationOrDepositType() {
        return ['reservation','deposit'].includes(this.type)
      },
      getDonorGender() {
        return this.$t(`donor.${this.donor_material_type}.nom`);
      },
      getDonorGender2() {
        return this.$t(`donor.${this.donor_material_type}.gen`);
      },
      getPartnerGender() {
        if(this.getPhenotype.partner) {
          return this.getPhenotype.partner.gender == 'FEMALE' ? this.$t(`recipient.FEMALE.partner_nom`) : this.$t(`recipient.MALE.partner_nom`);
        } else {
          return this.$t(`empty_value`);
        }
      },
      getPartnerGender2() {
        if(this.getPhenotype.partner) {
          return this.getPhenotype.partner.gender == 'FEMALE' ? this.$t(`recipient.FEMALE.partner_gen`) : this.$t(`recipient.MALE.partner_gen`);
        } else {
          return this.$t(`empty_value`);
        }
      }
    },
    emits: ['compare-dialog'],
    watch: {
      dialog(d) {
        this.$emit('compare-dialog', d)
      }
    },
    methods: {
      showDialog() {
        if (this.type == 'reservation') {
          this.fetchDonorAndRecipientData()
        } else {
          this.dialog = true;
        }
      },
      hideDialog() {
        this.dialog = false;
      },
      fetchDonorAndRecipientData() {
        this.dataFetching = true

        axios
          .get(`/api/donor/${this.donor_product_key}/${this.donor_material_type}/data`)
          .then((response) => {
            this.compareFetchedTable.donor = response.data._source.phenotype
            let request = null;
            if(this.type == 'reservation') {
              request = `/api/phenotype/reservation/${this.reservation_id}`
            } else {
              request = `/api/phenotype/${this.user_id}/all'`
            }
            axios.get(request)
              .then((response) => {
                  this.compareFetchedTable.own = response.data.own ?? {}
                if (response.data.own) {
                  this.compareFetchedTable.own.skinColor = { key: response.data.own.skinColor }
                  this.compareFetchedTable.own.race = { key: response.data.own.race }
                }
                this.compareFetchedTable.partner = response.data.partner ?? {}
                if (response.data.partner) {
                  this.compareFetchedTable.partner.skinColor = { key: response.data.partner.skinColor }
                  this.compareFetchedTable.partner.race = { key: response.data.partner.race }
                }
                this.dialog = true;
              })          
              .catch(err => {
                console.error(err);
              })
              .finally(() => {
                this.dataFetching = false
              })
          })
          .catch(err => {
            console.error(err);
            this.dataFetching = false
          })
      }
    }
}
</script>

<style lang="scss" scoped>
.compare-to-donor-component {
  .panel_header {
    @include ds-font-label-medium;
    color: var(--nsb-color-1, #0E346F);
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px; /* 157.143% */
  }
  .panel_subheader {
    @include nsb-font-label;
    color: var(--nsb-color-1, #0E346F);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }
  .button-details {
    @include nsb-font-container;
    font-size: 14px !important;
    opacity: 1;
    border-radius: 12px;
    background: var(--bank-secondary-300, #E3ECF8);
    &.coor-reservations-list {
      background: none;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0.14px;
    }
    .panel_shevron {
      height: 24px;
    }
  }
  .button-details:hover {
    border: none !important;
    box-shadow: none !important;
  }
}

.modal-header {
  @include nsb-gentium-bold;
  font-size: 28px;
  line-height: 32px;
}

.close{
  cursor: pointer;
  position: absolute;
  top: 22px;
  right: 15px;
  z-index: 10;
}
</style>